export default __webpack_public_path__ + "static/media/a11.7f90ba73.jpg";